import * as React from 'react';
import ActiveMap from './ActiveMap';
import PageInfo from "../../../common/PageInfo/PageInfo";

import * as styles from "./ActiveWorldMap.module.scss";
import TrackableElement from "../../../common/TrackableElement";

class ActiveWorldMap extends React.Component {
  constructor(props) {
    super(props);
    this.scroller = React.createRef();
  }

  componentDidMount() {
    this.scroller.current.scrollLeft += 350;
  }

  render() {
    return (
      <section className={styles.root}>
        <div className={styles.containerWrapper}>
          <div className={styles.mapContainer} ref={this.scroller}>
            <div>
              <ActiveMap/>
            </div>
            <div className={styles.countryContainer}>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Eesti"
                  className={styles.countryName}
                  style={{ left: '48%' }}
                  target="_blank"
                  href="https://flatfy.ee"
                >
                  Eesti
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Latvija"
                  className={styles.countryName}
                  style={{ left: '43%' }}
                  target="_blank"
                  href="https://flatfy.lv"
                >
                  Latvija
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Polska"
                  className={styles.countryName}
                  style={{ left: '36%' }}
                  target="_blank"
                  href="https://flatfy.pl"
                >
                  Polska
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Lietuva"
                  className={styles.countryName}
                  style={{ left: '36.2%' }}
                  target="_blank"
                  href="https://flatfy.lt"
                >
                  Lietuva
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Česká republika"
                  className={styles.countryName}
                  style={{ left: '35%' }}
                  target="_blank"
                  href="https://flatfy.cz"
                >
                  Česká republika
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Slovenská republika"
                  className={styles.countryName}
                  style={{ left: '35%' }}
                  target="_blank"
                  href="https://flatfy.sk"
                >
                  Slovenská republika
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Беларусь"
                  className={styles.countryName}
                  style={{ left: '35%' }}
                  target="_blank"
                  href="https://flatfy.by"
                >
                  Беларусь
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Україна"
                  className={styles.countryName}
                  style={{ left: '35%' }}
                  target="_blank"
                  href="https://flatfy.ua"
                >
                  Україна
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Қазақстан"
                  className={styles.countryName}
                  style={{ left: '35%' }}
                  target="_blank"
                  href="https://flatfy.kz"
                >
                  Қазақстан
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Magyarország"
                  className={styles.countryName}
                  style={{ left: '33%' }}
                  target="_blank"
                  href="https://hu.flatfy.com"
                >
                  Magyarország
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Republica Moldova"
                  className={styles.countryName}
                  style={{ left: '33%' }}
                  target="_blank"
                  href="https://flatfy.md"
                >
                  Republica Moldova
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="საქართველო"
                  className={styles.countryName}
                  style={{ left: '33%' }}
                  target="_blank"
                  href="https://flatfy.ge"
                >
                  საქართველო
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Oʻzbekiston"
                  className={styles.countryName}
                  style={{ left: '33%' }}
                  target="_blank"
                  href="https://flatfy.uz"
                >
                  Oʻzbekiston
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Кыргызстан"
                  className={styles.countryName}
                  style={{ left: '33%' }}
                  target="_blank"
                  href="https://flatfy.kg"
                >
                  Кыргызстан
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Slovenija"
                  className={styles.countryName}
                  style={{ left: '39%' }}
                  target="_blank"
                  href="https://flatfy.si"
                >
                  Slovenija
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="România"
                  className={styles.countryName}
                  style={{ left: '39%' }}
                  target="_blank"
                  href="https://flatfy.ro"
                >
                  România
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Azərbaycan"
                  className={styles.countryName}
                  style={{ left: '39%' }}
                  target="_blank"
                  href="https://flatfy.az"
                >
                  Azərbaycan
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="България"
                  className={styles.countryName}
                  style={{ left: '42%' }}
                  target="_blank"
                  href="https://bg.flatfy.com"
                >
                  България
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Türkiye Cumhuriyeti"
                  className={styles.countryName}
                  style={{ left: '42%' }}
                  target="_blank"
                  href="https://tr.flatfy.com"
                >
                  Türkiye Cumhuriyeti
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Ελληνική Δημοκρατία"
                  className={styles.countryName}
                  style={{ left: '44%' }}
                  target="_blank"
                  href="https://flatfy.gr"
                >
                  Ελληνική Δημοκρατία
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="دولة الإمارات العربية المتحدة"
                  className={styles.countryName}
                  style={{ left: '45%' }}
                  target="_blank"
                  href="https://flatfy.ae"
                >
                  دولة الإمارات العربية المتحدة
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Bhārat"
                  className={styles.countryName}
                  style={{ left: '57%' }}
                  target="_blank"
                  href="https://flatfy.in"
                >
                  Bhārat
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="ราชอาณาจักรไทย"
                  className={styles.countryName}
                  style={{ left: '59%' }}
                  target="_blank"
                  href="https://flatfy.in.th"
                >
                  ราชอาณาจักรไทย
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Nijeriya"
                  className={styles.countryName}
                  style={{ left: '37%' }}
                  target="_blank"
                  href="https://flatfy.ng"
                >
                  Nijeriya
                </TrackableElement>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Việt Nam"
                  className={styles.countryName}
                  style={{ left: '68%' }}
                  target="_blank"
                  href="https://flatfy.vn"
                >
                  Việt Nam
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Pilipinas"
                  className={styles.countryName}
                  style={{ left: '74%' }}
                  target="_blank"
                  href="https://flatfy.ph"
                >
                  Pilipinas
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Malaysia"
                  className={styles.countryName}
                  style={{ left: '75%' }}
                  target="_blank"
                  href="https://flatfy.my"
                >
                  Malaysia
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Indonesia"
                  className={styles.countryName}
                  style={{ left: '81%' }}
                  target="_blank"
                  href="https://flatfy.id"
                >
                  Indonesia
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="Chile"
                  className={styles.countryName}
                  style={{ left: '12%' }}
                  target="_blank"
                  href="https://flatfy.cl"
                >
                  Chile
                </TrackableElement>
              </div>
              <div className={styles.countryRow}>
                <TrackableElement
                  element="a"
                  eventCategory="map"
                  eventAction="country"
                  eventLabel="South Africa"
                  className={styles.countryName}
                  style={{ left: '47%' }}
                  target="_blank"
                  href="https://flatfy.co.za"
                >
                  South Africa
                </TrackableElement>
              </div>
            </div>
          </div>
          <PageInfo text='09 - flatfy local'/>
        </div>
      </section>
    )
  }
}

export default ActiveWorldMap;
